var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width || '20',"height":_vm.height || '18',"viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 0H2C0.897 0 0 0.897 0 2V16C0 17.103 0.897 18 2 18H18C19.103 18 20 17.103 20 16V2C20 0.897 19.103 0 18 0ZM17 4V6H12V4H17ZM12 8H17V10H12V8ZM2 16V2H9V16H2Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }